import { render } from "./MonthTransaction.vue?vue&type=template&id=1bf625b2"
import script from "./MonthTransaction.vue?vue&type=script&lang=js"
export * from "./MonthTransaction.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pushpan/Projects/WebApps/Python/Django/store_manage/punil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__